import React from "react";

export default function SectionCard({
  children,
  className = "",
  padded = true,
}) {
  return (
    <div
      className={`
        rounded-card
        border border-slate-100 dark:border-slate-700/60
        bg-white dark:bg-slate-800
        shadow-card
        ${padded ? "p-4" : ""}
        ${className}
      `}
    >
      {children}
    </div>
  );
}